// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sdpF","top":"styles_top__1G0Oq"};